import { render, staticRenderFns } from "./SectionsInfoinDialog.vue?vue&type=template&id=f80cdb3e&scoped=true"
import script from "./SectionsInfoinDialog.vue?vue&type=script&lang=js"
export * from "./SectionsInfoinDialog.vue?vue&type=script&lang=js"
import style0 from "./SectionsInfoinDialog.vue?vue&type=style&index=0&id=f80cdb3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f80cdb3e",
  null
  
)

export default component.exports